import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from 'oidc-react'
import Cookies from 'js-cookie'
import getEnv from '../lib/get-env.js'
import getCookieDomain from '../lib/get-cookie-domain.js'

const cookieName = getEnv('REACT_APP_TOKEN_COOKIE_NAME')
const isRedirectSignOut = getEnv('REACT_APP_DO_RP_INITIATED_LOGOUT') === 'true'

function SignOut() {
  const { signOutRedirect, signOut } = useAuth()
  const hasSignedOutRef = useRef(false)

  // Extract returnUrl from query parameters and store in localStorage
  const params = new URLSearchParams(useLocation().search)
  const returnUrl = params.get('returnUrl') || params.get('returnTo')
  localStorage.setItem('returnUrl', returnUrl)

  useEffect(() => {
    if (hasSignedOutRef.current) {
      return
    }

    if (cookieName) {
      const cookieOptions = {
        secure: true,
      }

      if (getEnv('NODE_ENV') === 'development') {
        cookieOptions.secure = false
      }

      const cookieDomain = getCookieDomain()
      if (cookieDomain) {
        cookieOptions.domain = cookieDomain
      }

      Cookies.remove(cookieName, cookieOptions)
    }

    if (isRedirectSignOut) {
      signOutRedirect()
    } else {
      signOut()
      if (returnUrl) {
        window.location.href = returnUrl
      }
    }

    hasSignedOutRef.current = true
  }, [signOutRedirect])

  return <div></div>
}

export default SignOut
